/**
 * Created by pubudud on 5/18/17.
 */

// Core modules
import { all } from 'redux-saga/effects';

// Sagas
import takeEveryApiGateWaySaga from './ApiGateWay/apiGateWaySaga';


/**
 * Root Saga for combining all other sagas
 */
export default function* rootSaga() {
  yield all([
    takeEveryApiGateWaySaga(),
  ]);
}



// WEBPACK FOOTER //
// ./src/saga/rootSaga.js